import { render, staticRenderFns } from "./TypeFilePPTXIcon.vue?vue&type=template&id=3910b022&"
import script from "./TypeFilePPTXIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFilePPTXIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports